











































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import IProduct from '@/lib/IProduct';
import ITopic from '@/lib/ITopic';
import Lockr from 'lockr';
import ProductCarousel2 from '@/components/ProductCarousel2.vue';
import StarRating from '@/components/StarRating.vue';
import VideoFile from '@/lib/VideoFile';
import VideoPlayer from '@/components/VideoPlayer.vue';
import { db } from '@/lib/ProductDatabase';
import { $nav } from '@/lib/KioskNavigation';

@Component({
  components: {
    ProductCarousel2,
    StarRating,
    VideoPlayer,
  },
})
export default class Topic extends Vue {

  // reactive properties

  // injected properties
  @Prop({ required: true }) topicId!: string;

  // non-reactive properties

  // lifecycle

  // computed
  get whitelabelPath(): string {
    return db.getWhitelabelPath();
  }
  get topic(): ITopic {
    return db.getTopicById(this.topicId);
  }
  get products(): IProduct[] {
    return this.topic.products;
  }
  get topicVideoFiles(): VideoFile[] {
    return this.topic.videos;
  }
  get seeProductsButtonTitle(): string {
    return `See ${this.topic.name} Products`;
  }

  // methods
  formattedPrice(priceInCents: number): string {
    const dollars = Math.floor(priceInCents / 100);
    const cents = priceInCents - (dollars * 100);
    return '$' + dollars + '.' + ((cents < 10) ? '0' : '') + cents;
  }

  btnSeeTopic(topic: string | null) {
    if ( topic ) {
      $nav.to(this, '/products/' + topic);
    }
    else {
      $nav.to(this, '/products');
    }
  }

  btnBack() {
    $nav.back(this);
  }

  btnHome() {
    $nav.home(this);
  }

}

